import { render, staticRenderFns } from "./PurchasePrice.vue?vue&type=template&id=07c177ee&scoped=true&"
import script from "./PurchasePrice.vue?vue&type=script&lang=ts&"
export * from "./PurchasePrice.vue?vue&type=script&lang=ts&"
import style0 from "./PurchasePrice.vue?vue&type=style&index=0&id=07c177ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c177ee",
  null
  
)

export default component.exports